import { Injector, Injectable, Inject } from '@angular/core';
import { Http, ResponseContentType } from '@angular/http';
import { Router } from '@angular/router';
import { PlatformLocation } from '@angular/common';

export abstract class ABaseService {
    private _router: Router;
    private _http: Http;
    private _platformLocation: PlatformLocation;

    data: {} = {};

    constructor(@Inject(Injector) protected _injector: Injector) {
    }

    private getHttp(): Http {
        return this._http || (this._http = this._injector.get(Http));
    }

    private getRouter(): Router {
        return this._router || (this._router = this._injector.get(Router));
    }

    private getLocation(): PlatformLocation {
        return this._platformLocation || (this._platformLocation = this._injector.get(PlatformLocation));
    }

    get currentUrl(): string {
        return this.getRouter().url;
    }
    get structurePath(): string {
        const href = this.getLocation().getBaseHrefFromDOM();
        let path = location.pathname;
        if (href && path && path.startsWith(href)) path = path.substr(href.length);

        return path;
    }

    downloadFile(blob: Blob, fileName: string): void {
        var url = window.URL.createObjectURL(blob);

        this.getHttp()
            .get(url, {
                responseType: ResponseContentType.Blob
            })
            .subscribe(res => {
                var url = window.URL.createObjectURL(res.blob());
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none');
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);
                a.remove(); // remove the element
            }, error => {
                //console.log('download error:', JSON.stringify(error));
            }, () => {
                //console.log('Completed file download.')
            });
    }

    /**
     * Navigate to the next url
     * @param url - Url to navigate
     * @param queryParams - Additional param for the navigation
     */
    navigate(url: string, extra?: any, hideNavigation: boolean = false) {
        if (hideNavigation) {
            if (!extra) extra = {};
            extra.skipLocationChange = true;
        }

        this.getRouter().navigate([url], extra);
    }
}
